import React, { Component } from 'react'
import styled from 'styled-components'
import { Info } from './DoctorInfo'
import { colors, ButtonReset } from '../../healtheraComponents'

export default class OrderSupportNote extends Component {
  state = {
    supportNoteEditMode: false,
    supportNoteValue: this.props.supportNote,
  }

  componentDidUpdate() {
    if (this.state.supportNoteValue === undefined && this.props.supportNote) {
      this.setState({ supportNoteValue: this.props.supportNote })
    }
  }

  toggleSupportNoteEditMode = () => {
    const { supportNoteEditMode } = this.state

    return this.setState({ supportNoteEditMode: !supportNoteEditMode })
  }

  saveSupportNote() {
    const { updateSupportNote } = this.props
    const { supportNoteValue } = this.state

    this.toggleSupportNoteEditMode()
    updateSupportNote(supportNoteValue)
  }

  render() {
    const { supportNote } = this.props
    const { supportNoteEditMode, supportNoteValue } = this.state

    return (
      <>
        {supportNote && (
          <Memos>
            <MemosRow>
              <Info>Support User Note:</Info>
              {supportNoteEditMode ? (
                <Save onClick={() => this.saveSupportNote()}>Save</Save>
              ) : (
                <Edit onClick={this.toggleSupportNoteEditMode}>Edit</Edit>
              )}
            </MemosRow>
            {supportNoteEditMode ? (
              <MemoTextarea
                name="textEdit"
                value={supportNoteValue}
                onChange={e => this.setState({ supportNoteValue: e.target.value })}
              />
            ) : (
              supportNoteValue
            )}
          </Memos>
        )}
      </>
    )
  }
}

export const Memos = styled.div`
  margin-top: auto;
  padding: 0 19px 19px 25px;
`

export const MemosRow = styled.div`
  display: flex;
`

export const Edit = styled(ButtonReset)`
  border-right: 3px solid;
  color: ${colors.HEALTHERA_GREEN};
  font-size: 16px;
  font-weight: 600;
  margin-left: auto;
  padding: 2px 8px;
  text-decoration: none;
`

export const Save = styled(ButtonReset)`
  border-right: 3px solid;
  color: ${colors.HEALTHERA_GREEN};
  font-size: 16px;
  font-weight: 600;
  margin-left: auto;
  padding: 2px 8px;
  text-decoration: none;
`

export const MemoTextarea = styled.textarea`
  border: 1px solid ${colors.GRAY_LIGHT};
  border-radius: 5px;
  box-sizing: border-box;
  font-family: inherit;
  font-size: inherit;
  max-height: 200px;
  padding: 3px 6px;
  resize: vertical;
  width: 100%;

  &:focus {
    border-color: ${colors.HEALTHERA_GREEN};
    outline: none;
  }
`
